import { useState } from 'react';
import { clsx } from 'clsx';
import { SideMenu } from '../SideMenu/SideMenu';
import { ErrorHeaderPopover } from '../ErrorHeaderPopover/ErrorHeaderPopover';
import styles from './Header.module.scss';
import VoltLogo from '../../../assets/logos/volt-logo.svg';
import { Button } from '@/ui/components';
import { Icon } from '@/ui/icons/Icon';
import { useFreshchat } from '@/features/support';
import { useMediaQuery } from '@/hooks';
import { CookiePopOver } from '@/features/cookie';

interface HeaderProps {
  className?: string;
}

export function Header({ className }: HeaderProps) {
  const [isSideMenuOpen, setIsSideMenuOpen] = useState(false);
  const { isDesktop } = useMediaQuery();
  const { showWidget } = useFreshchat();
  const variant = isDesktop ? 'desktop' : 'mobile';

  return (
    <>
      <header className={clsx(styles.header, className)}>
        <div className={styles.logoPill}>
          <VoltLogo className={styles.logo} aria-label="Volt" role="img" />
        </div>

        <div className={styles.actions}>
          <ErrorHeaderPopover variant={variant}>
            <Button
              trackingId={`header_help_${variant}`}
              variant="text"
              size="xsmall"
              className={styles.pill}
              contentClassName={styles.pillContent}
              onClick={showWidget}
            >
              <span className={styles.helpText}>Ajutor</span>
              <Icon name="question-circle" size={16} className={styles.icon} />
            </Button>
          </ErrorHeaderPopover>
          <CookiePopOver variant={variant}>
            <Button
              trackingId={`header_menu_toggle_${variant}`}
              variant="text"
              size="xsmall"
              iconOnly
              aria-label="Meniu"
              className={clsx(styles.pill, styles.menuPill)}
              contentClassName={styles.pillContent}
              rightIcon={<Icon name="menu" size={20} className={styles.icon} />}
              onClick={() => setIsSideMenuOpen((isOpen) => !isOpen)}
            />
          </CookiePopOver>
        </div>
      </header>

      <SideMenu isOpen={isSideMenuOpen} onClose={() => setIsSideMenuOpen(false)} />
    </>
  );
}
